import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { PageSection } from '../../Layout';
import qestIds from '../QestIds';
import {
  CombustionSection,
  PreparationSection,
  ResultsSection,
  WaterContentMethodASection,
  WaterContentMethodBSection,
} from './Astm/Sections';

let OrganicContentWorksheet = ({ createWorksheetSelector }) => {
  const isMethodA = useSelector(pipe(createWorksheetSelector('Preparation.Method'), (m) => m !== 'B'));

  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection heading="Measurements">
        {isMethodA ? <WaterContentMethodASection /> : <WaterContentMethodBSection />}
        <CombustionSection />
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <ResultsSection />
      </WorksheetResultsSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

OrganicContentWorksheet = withInjectedProps(OrganicContentWorksheet);
OrganicContentWorksheet.qestIds = [qestIds.organicContent.ASTM_D2974.rev2020];

export default OrganicContentWorksheet;
export { OrganicContentWorksheet };
